import { z } from 'zod';

import { BorrowerId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ChangePrimaryBorrowerEvent = BaseLoanEvent.extend({
  type: z.literal('changePrimaryBorrower'),
  from: z.object({
    id: BorrowerId,
    name: z.string().optional(),
  }),
  to: z.object({
    id: BorrowerId,
    name: z.string().optional(),
  }),
});
export type ChangePrimaryBorrowerEvent = z.infer<typeof ChangePrimaryBorrowerEvent>;
